import React, { useState } from "react";
import NACell from "../Reusable/DataTable/NACell";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/EndPoint";
import { useNavigate, useParams } from "react-router-dom";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import { useForm } from "react-hook-form";
import { tw } from "@careinfo/tailwind";
import Modal from "../Reusable/Modal";
import { toast } from "react-toastify";
import CreateIcon from "../../Icons/CreateIcon";
import usePostHook from "../../customHooks/usePostHook";
import { AccessControl } from "@careinfo/permission-required";
import SwitchButton from "../Reusable/SwitchButton";
import usePatchHook from "../../customHooks/usePatchHook";
import useDeleteHook from "../../customHooks/useDeleteHook";
import { TrashIcon } from "@heroicons/react/24/outline";
import Button from "../Reusable/Button";
import { classNames } from "../../utils/classNames";

function Organization() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { id } = useParams();
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const {
    formState: { errors },
    setError,
    setValue,
    getValues,
    watch,
    control,
    clearErrors,
  } = useForm<any>();
  const { mutateAsync } = usePostHook({
    queryKey: ["organizations", `organizations-${id}`],
  });
  const { mutateAsync: deleteOrganization, isLoading } = useDeleteHook({
    queryKey: ["organizations", `organizations-${id}`],
  });
  const handleAssign = async () => {
    const organization = watch("organization");
    const url = `${APIS.ORG_LIST}`;
    const formData = {
      client: organization,
      user: id,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });

      if (res?.status === 201) {
        setIsOpen(false);
      }
    } catch (err: any) {
      toast.error(err?.message || "Something went wrong");
    }
  };
  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.ORG_LIST}${id}/toggle-default/`;
    const formData = payload;
    try {
      await mutateAsync({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleDelete = async (
    id: any,
    setOpenDeletePopup: any,
    setError: any
  ) => {
    const url = `${APIS.ORG_LIST}${id}/`;
    try {
      const res = await deleteOrganization({ url, setError });
      if (res?.status === 200 || res?.status === 204) {
        setOpenDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "client.company_name",
      cell: NACell,
    },
    {
      header: "Default",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_user"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Action",
      accessorKey: "pk",
      cell: ({ row, getValue }: any) => (
        <div className={tw`grid grid-cols-2 items-center `}>
          <AccessControl
            children={
              <button
                type="button"
                disabled={isLoading || false}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedOrganization(row?.original.id);
                  setOpenDeletePopup(!openDeletePopup);
                }}
                className="focus:outline-none"
              >
                <TrashIcon color={"var(--primary)"} className={tw`w-5 h-5`} />
              </button>
            }
            allowedPermissions={["can_delete_group"]}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      {/* <Card title="Organization">
        <div className={tw`grid grid-cols-3 col-span-1`}>
          <ComboboxInput
            name="organization"
            placeholder={"Search Organization"}
            url={APIS.DELIVERY_CHARGE_TEMPLATE}
            queryKey={"organizations"}
            errors={errors?.organization}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      </Card> */}
      <DataTable
        url={`${APIS.ORG_LIST}`}
        queryKey={["organizations", `organizations-${id}`]}
        columns={defaultColumns}
        params={{ user: id }}
        tableName={"organizations-list"}
        actionMenu={
          <>
            <div
              className={tw`flex items-center justify-end w-fit border bg-gray-200 cursor-pointer px-2 py-1 rounded-md hover:bg-gray-100`}
              onClick={() => setIsOpen(true)}
            >
              <div className={tw`w-40 text-primary text-center`}>
                Assign New Organization
              </div>
            </div>
          </>
        }
      />
      <Modal
        isOpen={isOpen}
        setIsOpen={() => {
          setIsOpen(false);
        }}
        title={"Assign Organization to User"}
      >
        <div className={tw`grid grid-cols-1 md:grid-cols-4 gap-3 items-end`}>
          <div className={tw`md:col-span-3`}>
            <ComboboxInput
              name="organization"
              placeholder={"Select Organization to Assign"}
              url={APIS.ORGANIZATION}
              queryKey={"organization"}
              errors={errors?.organization}
              params={{}}
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>

          <button
            type="button"
            onClick={handleAssign}
            className={tw`
      h-10
      flex items-center justify-center gap-2
      rounded-md
      bg-primary
      text-white
      font-medium
      px-4
      hover:bg-primary-dark
      focus:outline-none
      focus-visible:ring-2
      focus-visible:ring-primary
      ring-offset-2
      disabled:opacity-50
      disabled:cursor-not-allowed
    `}
          >
            <CreateIcon color="white" />
            Assign
          </button>
        </div>
      </Modal>
      <Modal isOpen={openDeletePopup} setIsOpen={setOpenDeletePopup} title={""}>
        <div className={tw`flex flex-col justify-center items-center  h-fit`}>
          <p className={tw`text-lg font-semibold mb-4`}>
            Are you sure you want to delete ?
          </p>
          <div className={tw`mt-6 flex gap-x-6 items-center`}>
            <div className={tw`w-24`}>
              <Button
                label={"Yes"}
                isLoading={isLoading}
                onClick={() =>
                  handleDelete(
                    selectedOrganization,
                    setOpenDeletePopup,
                    setError
                  )
                }
              />
            </div>
            <div>
              <button
                type="button"
                className={tw`w-full px-[24px] py-2 rounded  focus:outline-none bg-[#EEF5F4]`}
                onClick={() => setOpenDeletePopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Organization;
